/**
 * @file CartAfterAddGroup.tsx
 * @description Группа «После «В корзину»» «Вида корзины» (phase19.16, SB120
 * этап 4; uiux-cart §4, §6): «Открыть корзину / Окно на 4 с / Только
 * счётчик». При виде «окно» — совет «Окно на 4 с»; «Только счётчик» —
 * предупреждение под полем (не запрет). Выбор «Окно на 4 с» канва сразу
 * показывает (`useCanvasCart`, `view: "peek"`).
 */

import { SITE_CART_AFTER_ADD, SITE_CART_AFTER_ADD_LABELS, type SiteCartAfterAdd } from "@chaiberi/shared";

import { FieldHint, SettingsGroup } from "../../ui/settings-groups";
import { Segmented } from "../Segmented";
import { useCartLook } from "./cart-look-context";
import { CartFields } from "./CartFields";
import { CartWarnings } from "./CartWarnings";
import { afterSummary, groupHasWarning } from "../../../lib/site-view/cart-look";

/** Что увидит покупатель — подсказка по выбору (реестр). */
const AFTER_HINTS: Readonly<Record<SiteCartAfterAdd, string>> = {
  open: "Корзина открывается сразу после добавления.",
  peek: "Окно на 4 секунды: добавленный товар, «Итого» и две кнопки; при наведении не закрывается.",
  badge: "Меняется только число на значке корзины.",
};

/** Совет при виде «окно» (uiux-cart §4). */
export const CART_PEEK_ADVICE = "При окне из шапки советуем «Окно на 4 с».";

export function CartAfterAddGroup() {
  const { cart, warnings, change } = useCartLook();
  return (
    <SettingsGroup
      id="after"
      title="После «В корзину»"
      tocLabel="После"
      hint="Что видит покупатель, добавив товар."
      summary={afterSummary(cart)}
      status={groupHasWarning(warnings, "after") ? "warning" : undefined}
    >
      <CartFields>
        <Segmented
          aria-label="После «В корзину»"
          options={SITE_CART_AFTER_ADD.map((value) => ({ value, label: SITE_CART_AFTER_ADD_LABELS[value] }))}
          value={cart.afterAdd}
          onChange={(afterAdd) => change({ afterAdd })}
        />
        <FieldHint className="mt-0">{AFTER_HINTS[cart.afterAdd]}</FieldHint>
        {cart.mode === "popover" && cart.afterAdd !== "peek" ? <FieldHint className="mt-0">{CART_PEEK_ADVICE}</FieldHint> : null}
        <CartWarnings path="cart.afterAdd" />
      </CartFields>
    </SettingsGroup>
  );
}
